// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/progress","root":"progress-m__root__2vX10","output":"progress-m__output__1KJw_","bar":"progress-m__bar__1uSqt","progress":"progress-m__progress__3V_Rl"};